import {HEADER_INFO} from '@client/constants/headerInfo';

export default class EnterpriseSettings {
  constructor() {
    this.features = ['Chat', 'FooterMenu', 'SSO', 'RiskGauge', 'ClassicMode'];
    this.featuresLoaded = false;
    this.enterpriseId = null;
    this.eid = null;
    this.userType = null;
    this.header = HEADER_INFO;
    this.sso = {
      loginUrl: process.env.VUE_APP_SSO_LOGIN_URL,
    };
    this.gaugeType = 'PRINCIPAL';
  }
}
